{
    "(save {highestYearlyDiscount}%)": "(ušetřete {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dní zdarma",
    "{amount} off": "Sleva {amount}",
    "{amount} off for first {number} months.": "Sleva {amount} na prvních {number} měsíců.",
    "{amount} off for first {period}.": "Sleva {amount} na první {period}.",
    "{amount} off forever.": "Sleva {amount} navždy.",
    "{discount}% discount": "{discount}% sleva",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} již nebude dostávat newsletter {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} již nebude dostávat e-maily, když někdo odpoví na vaše komentáře.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} již nebude dostávat tento newsletter.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dní zdarma",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Účet",
    "Account details updated successfully": "",
    "Account settings": "Nastavení účtu",
    "Add a personal note": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Po skončení zkušební doby vám bude účtována běžná cena pro vybranou úroveň. Vždy můžete předtím zrušit odběr.",
    "Already a member?": "Již jste členem?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Došlo k neočekávané chybě. Zkuste to prosím znovu nebo <a>kontaktujte podporu</a>, pokud chyba přetrvává.",
    "Back": "Zpět",
    "Back to Log in": "Zpět na přihlášení",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Černý pátek",
    "Bluesky": "",
    "Cancel anytime.": "Zrušit kdykoli.",
    "Cancel subscription": "Zrušit odběr",
    "Canceled": "",
    "Cancellation reason": "Důvod zrušení",
    "Change": "Změnit",
    "Change plan": "",
    "Check spam & promotions folders": "Zkontrolujte složky spam a propagace",
    "Check with your mail provider": "Zkontrolujte u svého poskytovatele e-mailu",
    "Check your inbox to verify email update": "",
    "Choose": "Vybrat",
    "Choose a different plan": "Vybrat jiný plán",
    "Choose a plan": "",
    "Choose your newsletters": "Vyberte si newsletter",
    "Click here to retry": "Klikněte zde pro opakování",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Zavřít",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Komentáře",
    "Complimentary": "Zdarma",
    "Confirm": "Potvrdit",
    "Confirm cancellation": "Potvrdit zrušení",
    "Confirm subscription": "Potvrdit odběr",
    "Contact support": "Kontaktovat podporu",
    "Continue": "Pokračovat",
    "Continue subscription": "Pokračovat v odběru",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Nelze se přihlásit. Přihlašovací odkaz vypršel.",
    "Could not update email! Invalid link.": "Nelze aktualizovat e-mail! Neplatný odkaz.",
    "Create a new contact": "Vytvořit nový kontakt",
    "Current plan": "Aktuální plán",
    "Delete account": "Smazat účet",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Nechtěli jste to udělat? Spravujte své předvolby <button>zde</button>.",
    "Don't have an account?": "Nemáte účet?",
    "Edit": "Upravit",
    "Email": "E-mail",
    "Email confirmation link expired.": "",
    "Email newsletter": "E-mailový newsletter",
    "Email newsletter settings updated": "",
    "Email preferences": "Předvolby e-mailu",
    "Email preferences updated.": "",
    "Emails": "E-maily",
    "Emails disabled": "E-maily vypnuty",
    "Ends {offerEndDate}": "Končí {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "Zadejte svou e-mailovou adresu",
    "Enter your name": "Zadejte své jméno",
    "Error": "Chyba",
    "Expires {expiryDate}": "Vyprší {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "Forever": "Navždy",
    "Free Trial – Ends {trialEnd}": "Zkušební verze zdarma – Končí {trialEnd}",
    "Get help": "Získat pomoc",
    "Get in touch for help": "Kontaktujte nás pro pomoc",
    "Get notified when someone replies to your comment": "Dostávat upozornění, když někdo odpoví na váš komentář",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Dát zpětnou vazbu k tomuto příspěvku",
    "Help! I'm not receiving emails": "Pomoc! Nedostávám e-maily",
    "Here are a few other sites you may enjoy.": "Zde je několik dalších webů, které by se vám mohly líbit.",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Pokud je newsletter označen jako spam, e-maily jsou pro tuto adresu automaticky deaktivovány, abyste již nedostávali žádné nevyžádané zprávy.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Pokud bylo nahlášení spamu neúmyslné nebo chcete znovu začít dostávat e-maily, můžete se znovu přihlásit k odběru e-mailů kliknutím na tlačítko na předchozí obrazovce.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Pokud nyní zrušíte svůj odběr, budete mít přístup až do {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Pokud máte firemní nebo institucionální e-mailový účet, obraťte se na své IT oddělení a požádejte je, aby povolili přijímání e-mailů od {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Odkaz pro přihlášení byl odeslán do vaší e-mailové schránky. Pokud nepřijde do 3 minut, zkontrolujte prosím svou složku nevyžádaných zpráv (spam).",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Pokud chcete znovu začít dostávat e-maily, nejlepším dalším krokem je zkontrolovat, zda není problém s vaší e-mailovou adresou v našich záznamech, a poté kliknout na tlačítko pro opětovné přihlášení na předchozí obrazovce.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Pokud nedostáváte e-mailový newsletter, k němuž jste se přihlásili, zde je několik věcí, které můžete zkontrolovat.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Pokud jste provedli všechny tyto kontroly a stále nedostáváte e-maily, můžete požádat o podporu kontaktováním {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "V případě, že při pokusu o odeslání newsletteru dojde k trvalému selhání, budou e-maily na účtu deaktivovány.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Ve svém e-mailovém klientu přidejte {senderEmail} do seznamu kontaktů. Tím dáte svému poskytovateli e-mailu signál, že e-maily odeslané z této adresy jsou důvěryhodné.",
    "Invalid email address": "Neplatná e-mailová adresa",
    "Invalid verification code": "",
    "Jamie Larson": "Jamie Larson",
    "jamie@example.com": "jamie@example.com",
    "Less like this": "Méně podobných",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Ujistěte se, že e-maily nekončí omylem ve složkách Spam nebo Propagace ve vaší schránce. Pokud ano, klikněte na \"Označit jako ne spam\" a/nebo \"Přesunout do doručené pošty\".",
    "Manage": "Spravovat",
    "Maybe later": "Možná později",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Členství není k dispozici, kontaktujte vlastníka pro přístup.",
    "month": "",
    "Monthly": "Měsíčně",
    "More like this": "Víc podobných",
    "More options": "",
    "Name": "Jméno",
    "Need more help? Contact support": "Potřebujete další pomoc? Kontaktujte podporu",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Newslettery mohou být na vašem účtu deaktivovány ze dvou důvodů: Předchozí e-mail byl označen jako spam, nebo pokus o odeslání e-mailu skončil trvalým selháním (odrazem).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Nepřicházejí vám e-maily?",
    "Now check your email!": "Zkontrolujte svou e-mailovou schránku!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Po opětovném přihlášení, pokud stále nevidíte e-maily ve své schránce, zkontrolujte složku spam. Někteří poskytovatelé e-mailových schránek si uchovávají záznam o předchozích stížnostech na spam a budou nadále označovat e-maily. Pokud k tomu dojde, označte nejnovější newsletter jako 'Není spam', aby se přesunul zpět do vaší hlavní schránky.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "Trvalé selhání (vrátilo se)",
    "Phone number": "Telefonní číslo",
    "Plan": "Plán",
    "Plan checkout was cancelled.": "Platba za plán byla zrušena.",
    "Plan upgrade was cancelled.": "Upgrade plánu byl zrušen.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Prosím kontaktujte {supportAddress} pro úpravu vašeho zadarmového předplatného.",
    "Please enter {fieldName}": "Prosím zadejte {fieldName}",
    "Please fill in required fields": "Prosím vyplňte povinná pole",
    "Podcasts": "",
    "Re-enable emails": "Znovu povolit e-maily",
    "Recommendations": "Doporučení",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Obnovuje se za {price}.",
    "Resume subscription": "",
    "Retry": "Zkusit znovu",
    "Save": "Uložit",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send an email and say hi!": "Pošlete e-mail a pozdravte!",
    "Send an email to {senderEmail} and say hello. This can also help signal to your mail provider that emails to and from this address should be trusted.": "Pošlete e-mail na {senderEmail} s pozdravem. Tím také můžete dát signál svému poskytovateli e-mailu, že e-maily z této adresy a na ni by měly být důvěryhodné.",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Odesílání přihlašovacího odkazu...",
    "Sending...": "Odesílání...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "Zobrazit vše",
    "Sign in": "Přihlásit se",
    "Sign out": "Odhlásit se",
    "Sign up": "Registrovat se",
    "Signup error: Invalid link": "Chyba registrace: Neplatný odkaz",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Něco se pokazilo, zkuste to prosím později.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Omlouváme se, to nefungovalo.",
    "Spam complaints": "Stížnosti na spam",
    "Start {amount}-day free trial": "Začít {amount}denní zkušební verzi zdarma",
    "Starting {startDate}": "Začíná {startDate}",
    "Starting today": "Začíná dnes",
    "Submit feedback": "Odeslat zpětnou vazbu",
    "Subscribe": "Odebírat",
    "Subscribed": "odebíráte",
    "Subscription plan updated successfully": "",
    "Success": "Úspěch",
    "Success! Check your email for magic link to sign-in.": "Úspěch! Zkontrolujte svůj e-mail pro magický odkaz k přihlášení.",
    "Success! Your account is fully activated, you now have access to all content.": "Úspěch! Váš účet je plně aktivován, nyní máte přístup k veškerému obsahu.",
    "Success! Your email is updated.": "Úspěch! Váš e-mail byl aktualizován.",
    "Successfully unsubscribed": "Úspěšné odhlášení",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Děkujeme za přihlášení k odběru. Než začnete číst, níže je několik dalších webů, které by se vám mohly líbit.",
    "Thank you for your support": "Děkujeme za vaši podporu",
    "Thank you for your support!": "Děkujeme za vaši podporu!",
    "Thanks for the feedback!": "Děkujeme za zpětnou vazbu!",
    "That didn't go to plan": "Něco se nepovedlo",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "E-mailová adresa, kterou pro vás máme, je {memberEmail} — pokud to není správně, můžete ji aktualizovat v <button>nastavení vašeho účtu</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Při odesílání vaší zpětné vazby došlo k problému. Zkuste to prosím znovu o něco později.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "Při zpracování vaší platby došlo k chybě. Zkuste to prosím znovu.",
    "There was an error sending the email, please try again": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "Tento web je pouze pro pozvané, kontaktujte provozovatele pro přístup.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Tento web momentálně nepřijímá platby.",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Pro dokončení registrace klikněte na potvrzovací odkaz ve vaší e-mailové schránce. Pokud nepřijde do 3 minut, zkontrolujte prosím složku nevyžádaných zpráv (spam)!",
    "To continue to stay up to date, subscribe to {publication} below.": "Chcete-li zůstat informováni, přihlaste se k odběru {publication} níže.",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Vyzkoušejte zdarma na {amount} dní, poté {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Odemkněte přístup ke všem newsletterům tím, že se stanete placeným odběratelem.",
    "Unsubscribe from all emails": "Odhlásit se od všech e-mailů",
    "Unsubscribed": "Odhlášeno",
    "Unsubscribed from all emails.": "Odhlášeno ze všech e-mailů.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Odhlášení ze newsletterů nezruší váš placený odběr {title}",
    "Update": "Aktualizovat",
    "Update your preferences": "Aktualizovat předvolby",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Ověřovací odkaz odeslán, zkontrolujte svou schránku",
    "Verify your email address is correct": "Ověřte, zda je vaše e-mailová adresa správná",
    "Verifying...": "",
    "View plans": "Zobrazit plány",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Nemohli jsme vás odhlásit, protože e-mailová adresa nebyla nalezena. Kontaktujte prosím provozovatele webu.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "Vítejte zpět, {name}!",
    "Welcome back!": "Vítejte zpět!",
    "Welcome to {siteTitle}": "Vítejte na {siteTitle}",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Když schránka nepřijme e-mail, běžně se tomu říká odraz. V mnoha případech to může být dočasné. V některých případech však může být odražený e-mail vrácen jako trvalé selhání, když je e-mailová adresa neplatná nebo neexistující.",
    "Why has my email been disabled?": "Proč byl můj e-mail deaktivován?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Ročně",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "V současné době máte bezplatné členství, upgradujte na placené předplatné pro plný přístup.",
    "You have been successfully resubscribed": "Úspěšně jste se opět přihlásili k odběru",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "V současné době nedostáváte e-maily",
    "You're not receiving emails": "Nedostáváte e-maily",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Nepřicházejí vám e-maily, protože jste buď označili nedávnou zprávu jako spam, nebo doručování zpráv na vámi zadaný e-mail nefunguje.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Úspěšně jste se přihlásili.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Úspěšně jste se přihlásili k odběru <strong>{siteTitle}</strong>",
    "Your account": "Váš účet",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Vaše připomínky pomáhají ladit a tvořit obsah webu.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Vaše předplatné vyprší {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Vaše předplatné se obnoví {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Vaše předplatné začne {subscriptionStart}"
}
